import {
  Component,
  inject,
  OnInit,
  Renderer2,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { isPlatformBrowser, LowerCasePipe } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { AppSettingsService } from './services/app-settings/app-settings.service';
import { environment } from '@environments/environment';
import { BootstrapInitDirective } from '@directives/bootstrap/bootstrap-init.directive';
import { ContactFabComponent } from '@components/contact-fab/contact-fab.component';
import { PopupModalShellComponent } from '@components/popup-modal-shell/popup-modal-shell.component';
import { ContactService } from './services/contact/contact.service';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';
import { FaviconService } from '@services/favicon/favicon.service';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';

@Component({
  selector: 'app-root',
  imports: [
    LowerCasePipe,
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    PopupModalShellComponent,
    ContactFabComponent,
    BootstrapInitDirective,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  @ViewChild(ContactFabComponent)
  set contactFab(contactFab: ContactFabComponent | undefined) {
    this.contactService.fab = contactFab ?? null;
  }

  router = inject(Router);
  appSettingsService = inject(AppSettingsService);
  private renderer2 = inject(Renderer2);
  private contactService = inject(ContactService);
  // Initialize favicon service to set the favicon based on CMS data
  private _faviconService = inject(FaviconService);

  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.addGoogleMapsScript();
      this.addPaySimpleScript();
    }
  }

  addGoogleMapsScript() {
    const scriptId = 'google-maps-api-script';
    // Prevent adding the script if it's already loaded or google object is present
    if (
      document.getElementById(scriptId) ||
      (typeof window.google === 'object' &&
        typeof window.google.maps === 'object')
    ) {
      return;
    }

    const script = this.renderer2.createElement('script') as HTMLScriptElement;
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKeyRobynPay}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;
    this.renderer2.appendChild(document.body, script);
  }
  addPaySimpleScript() {
    const script = this.renderer2.createElement('script') as HTMLScriptElement;
    script.src = `${environment.paySimpleEnvironment}/paysimplejs/v1/scripts/client.js`;
    script.type = 'text/javascript';
    this.renderer2.appendChild(document.body, script);
  }

  // feature flag
  private readonly featureFlagService = inject(FeatureFlagService);
  readonly showContactFab = this.featureFlagService.isFeatureActive(
    FeatureFlagEnum.CHAT_BUBBLE,
  );
}

// TOUCH_BUILD: 2026-02-23T20:18:28.555Z
